import { render, staticRenderFns } from "./SolicitudHistoricaDetail.vue?vue&type=template&id=604ad32a"
import script from "./SolicitudHistoricaDetail.vue?vue&type=script&lang=js"
export * from "./SolicitudHistoricaDetail.vue?vue&type=script&lang=js"
import style0 from "./SolicitudHistoricaDetail.vue?vue&type=style&index=0&id=604ad32a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports